import React from 'react'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

const CustomCheckboxField = (props) => {
  const { label, checked, required, error, disabled, handleChange, size, field_key, index, sx, sxLabel } = props

  const onChange = (event) => {
    handleChange(event.target.checked, field_key, index)
  }
  
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          size={size ? size : 'small'}
          sx={{ ...sx, opacity: disabled ? 0.7 : 1 }}
        />
      }
      label={ label ? <Box sx={{ ...sxLabel, opacity: disabled ? 0.7 : 1 }}>{label}</Box> : '' }
      required={required ? required : false}      
      onChange={onChange}
      sx={{ color: error && '#ff0000' }}
    />
  )
}

export default CustomCheckboxField